module.exports = __webpack_public_path__ + "static/2-Tri-08-8e54c75e257e950917f11754b4aa1693.png";